import '../styles/votecard.scss'
import ReactGA from 'react-ga';

const VoteCard = (props) => {
    const onInputChange = () => {
        props.change(props.gameName, props.optionNumber)
    }

    return (
        <div className="card-wrapper">
            <label htmlFor={`${props.gameName}-${props.optionNumber}`}>
                <div className="card-container" style={{backgroundImage: `url(${process.env.PUBLIC_URL + props.bg})`, backgroundColor: '#FFE600'}}>
                    <div className="cover-container">
                            <img src={`.${props.bg}`} alt="cover" className="cover-img" />
                    </div>
                    <h1 className="cover-title">
                            {`Reverse Cover #${props.optionNumber}`}
                    </h1>
                    <input type="radio" value={`${props.gameName} Cover ${props.optionNumber}`} name={props.gameName} onInput={onInputChange}
                    id = {`${props.gameName}-${props.optionNumber}`}/>
                </div>
            </label>
        </div>
    )
}

export default VoteCard;